import { NormalizedPayoutData } from "../types";
import { FeeType, freeItems, getFeeName } from "views/statements-id/utils";
import FeeDisplay from "shared/components/FeeDisplay";

interface BillingDetailSummaryProps {
  summaryData?: NormalizedPayoutData;
}

export const BillingDetailSummary = ({
  summaryData
}: BillingDetailSummaryProps) => {
  return (
    <div className="rounded-lg border border-alpha-100 bg-white print:border-none">
      <div className="grid grid-cols-12 px-5 py-3 text-sm font-bold print:px-2 print:py-1">
        <p className="col-span-6 text-sm font-medium text-content-300">Item</p>
        <p className="text-right col-span-2 text-sm font-medium text-content-300 no-print">
          Item Value
        </p>
        <p className="text-right col-span-2 text-sm font-medium text-content-300 hidden print:inline">
          Item Cost
        </p>
        <p className="text-center col-span-2 text-sm font-medium text-content-300">
          Quantity
        </p>
        <p className="text-right col-span-2 text-sm font-medium text-content-300">
          Amount
        </p>
      </div>
      {summaryData?.items.map((property, propertyIndex: number) => {
        return (
          <div key={propertyIndex}>
            <div className="print-color-adjust bg-alpha-40 px-4 py-3 print:px-2 print:py-1">
              <span className="text-sm font-bold text-content-1000">
                {property.property.name}
                {/* Adjust here based on your SummaryItem structure */}
              </span>
              <span className="mx-2 inline-block h-1.5 w-1.5 rounded-full bg-alpha-80" />
              <span className="text-xs font-medium text-content-300">
                {property.property.address.one_line_address}{" "}
                {/* Adjust here based on your SummaryItem structure */}
              </span>
            </div>
            {Object.values(property.stats).map(
              ({ name, feeInCents, count }) => {
                if (freeItems.includes(name)) return;

                return (
                  <div
                    key={`${propertyIndex}-${name}-${count}`}
                    className="grid grid-cols-12 gap-4 px-5 py-3 print:px-2"
                  >
                    <p className="col-span-6 text-sm font-medium text-content-500">
                      {getFeeName(name as FeeType)}
                    </p>
                    <FeeDisplay
                      feeInCents={feeInCents / count}
                      currency="USD"
                      className="text-right text-sm font-medium col-span-2"
                    />
                    <p className="text-center col-span-2 text-sm font-medium text-content-1000">
                      {count}
                    </p>
                    <FeeDisplay
                      feeInCents={feeInCents}
                      currency="USD"
                      className="text-right text-sm font-medium col-span-2"
                    />
                  </div>
                );
              }
            )}

            <FeeDisplay
              feeInCents={property.propertyTotal}
              currency="USD"
              className="text-sm font-medium w-full flex justify-end p-5 border-t border-alpha-40 text-left print:px-2"
              label="Total"
              labelClassName="hidden print:inline font-bold text-content-1000"
            />
          </div>
        );
      })}
      <div className="flex items-center justify-between bg-alpha-40 px-4 py-3 no-print">
        <p className="text-base font-bold text-content-1000">Total</p>
        <FeeDisplay
          feeInCents={summaryData?.total || 0}
          currency="USD"
          className="text-sm font-medium"
        />
      </div>

      <div className="bg-alpha-40 px-2 py-1 print:px-2 hidden print:flex justify-end print:border-t print:border-alpha-100">
        <FeeDisplay
          feeInCents={summaryData?.total || 0}
          currency="USD"
          className="font-medium"
          label="Total"
          labelClassName="text-content-1000 font-bold"
        />
      </div>
    </div>
  );
};
